import Backbone from 'backbone'
import template from './alert-details.hbs'
import _ from 'lodash'
import AlertForm from 'scoreboard/admin/alerts/alert-form'

/**
 * A dialog for editing and viewing alert details
 * (e.g. the message, recipients, and whether it's a popup)
 * for a "Send Alert" form action
 */
const AlertDetails = Backbone.View.extend({
	className: 'alert-details',
	events: {
		'click .done': 'onClickDone'
	},
	/**
	 * @param {Object} options
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.append(template())
		this.renderAlertForm()
		return this
	},

	renderAlertForm: function() {
		let { message, recipients, popup } = this.options
		this.alertForm = new AlertForm({
			displaySubmitOptions: false,
			url: 'api/alerts/recipients',
			message,
			recipients,
			popup,
			// pass in the primary button selector for the formView since
			// dialog buttons are outside the alert-form form tag
			primaryButtonEl: () => {
				return this.$('.button-primary.done')
			},
		})
		this.$('.dialog-body-content').append(this.alertForm.el)
		this.alertForm.render()
	},

	onClickDone: function() {
		if (_.isNil(this.alertForm.formView.validate())) {
			this.trigger('done', this.alertForm.gatherData())
		} else {
			// if the form is invalid, don't close the dialog and
			// disable the primary button (since it is outside the form)
			this.alertForm.formView.primaryButton.disable()
			return false
		}
	},

	autoRemove: true
})

export default AlertDetails
AlertDetails.__filename__ = 'forms/widgets/alert-details.js'
